"use client";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/site/Header";
import Footer from "../../components/site/Footer";

export default function Terms() {
  // Newsletter/CTA را در این صفحه مخفی نگه‌می‌داریم
  useEffect(() => {
    const sel = ".cta-one, .newsletter-one, section[class*='subscribe'], section[class*='newsletter']";
    const prev = new Map();
    const hideAll = () => {
      document.querySelectorAll(sel).forEach((el) => {
        if (!prev.has(el)) prev.set(el, el.style.display);
        el.style.display = "none";
      });
    };
    hideAll();
    const obs = new MutationObserver(hideAll);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => {
      obs.disconnect();
      prev.forEach((v, el) => { if (document.body.contains(el)) el.style.display = v || ""; });
    };
  }, []);

  return (
    <>
      <Header />

      <main className="nsm-legal">
        {/* HERO */}
        <section className="nsm-legal__hero">
          <div className="container">
            <p className="nsm-legal__backwrap">
              <Link to="/" className="nsm-legal__back">Back To Home</Link>
            </p>
            <h1 className="nsm-legal__title">Terms &amp; Conditions</h1>
            <p className="nsm-legal__updated">Last updated: 01 Sep 2025</p>
          </div>
        </section>

        {/* CONTENT */}
        <section className="nsm-legal__section">
          <div className="container">
            <div className="nsm-legal__card">
              <ol className="nsm-legal__ol">
                <li>
                  <h3>Introduction</h3>
                  <p>
                    These Terms govern your use of the Next Super Model website and services. By
                    accessing or using the site, you agree to these Terms.
                  </p>
                </li>

                <li>
                  <h3>Tickets &amp; Refunds</h3>
                  <ul className="nsm-legal__ul">
                    <li>Tickets are issued by our ticketing partner. Their terms apply to purchase &amp; refunds.</li>
                    <li>Please check event date/time and venue details before purchase.</li>
                  </ul>
                </li>

                <li>
                  <h3>Content &amp; Media</h3>
                  <ul className="nsm-legal__ul">
                    <li>Photos and videos taken at the event may be used for promotional purposes.</li>
                  </ul>
                </li>

                <li>
                  <h3>Contact</h3>
                  <p>
                    Questions? <Link to="/contact">Contact us</Link>.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
